<template>
  <div>
    <v-card class="ma-4" id="head_height">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold">
          <v-icon class="mr-2">mdi-file-find-outline</v-icon>서약 현황
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>

    <v-card class="ma-4" v-resize="onResize">
      <v-data-table
        :headers="headers"
        :items="Records"
        v-model="selected"
        @click:row="handleClick"
        :items-per-page="15"
        item-key="cPledgeId"
        :height="ChangableHeight"
        fixed-header>
        <template v-slot:item.cPledgeDateTime="{ item }">
          {{item.cPledgeDateTime.substring(0,10)}}
        </template>
        <template v-slot:item.ShowPledge="{  }">
          <div class="hidden-sm-and-down">
            <!-- <v-icon @click="ShowPledgeDialog(item.cPledgeId)" color="black">search</v-icon> -->
            <v-btn icon><v-icon color="black">search</v-icon></v-btn>
          </div>
          <div class="d-md-none">
            <v-btn icon><v-icon color="black">search</v-icon></v-btn>
          </div>
        </template>
        <template v-slot:item.cAgree="{ item }">
          <v-chip label small :color="getAgreeColor(item.cAgree)" class="white--text">{{getAgree(item.cAgree)}}</v-chip>
        </template>
        <template v-slot:no-data>
          <div class="black--text">조회 결과가 없습니다.</div>
        </template>
      </v-data-table>
    </v-card>

    <PledgeDialog ref="PledgeDialogRef"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';

import PledgeDialog from '../components/PledgeDialog.vue';

export default {
  components: {
    PledgeDialog,
  },
  data: () => ({
    selected : [],
    ChangableHeight : "",
    headers: [
      { text: '서약일자', value: 'cPledgeDateTime', align: 'start'},
      { text: '서약유형', value: 'cType',align: 'center',},
      { text: '서약자 정보', value: 'cCustomNm',align: 'center',},
      { text: '서약서 상세보기', value: 'ShowPledge',align: 'center',},
      { text: '동의여부', value: 'cAgree',align: 'center',},
    ],
    Records : [],
    editedItem : {
      iEditIndex : -1,
      bAgree : "",
      cPledgeId : "",
      sImgPledge : "",
    },
  }),
  computed: {
    ...mapState(["CustomInfo"]),
  },
  created() {
  },

  mounted() {
    this.GetPledgeLog()
  },

  methods : {
    onResize(){
      let h1 = document.getElementById('footer_height').clientHeight
      let h2 = document.getElementById('head_height').clientHeight

      let iCalcHeight = window.innerHeight - h1 - h2 - 136

      if (iCalcHeight >= 300) {
        this.ChangableHeight = String(iCalcHeight) + "px"
      } else {
        this.ChangableHeight = "300px"
      }
    },

    // 데이터 테이블 내부 데이터 클릭 시
    handleClick(value) {
      this.selected = [value]
      this.ShowPledgeDialog(value.cPledgeId, value.cPledgeDateTime);
    },

    // 데이터 테이블 목록 두 번 클릭 시 실행 함수
    handleDoubleClick() {
      if (this.selected.length > 0){
        this.editedItem.iEditIndex = this.Records.indexOf(this.selected[0])
        this.ShowPledgeDialog(this.selected[0].cPledgeId, this.selected[0].cPledgeDateTime);
      }
    },

    // 서약서 다이올로그창 열기
    ShowPledgeDialog(PledgeId, date) {
      this.$refs.PledgeDialogRef.ShowDialog(PledgeId, date)
    },

    // 값이 안들어 왔을때 "N" 반환하기
    getAgree(cAgree) {
      if (cAgree == "" || cAgree == "N") return "미동의"
      else return "동의"
    },
    
    // 값이 안들어 왔을때 "N" 반환하기
    getAgreeColor(cAgree) {
      if (cAgree == "" || cAgree == "N") return "red lighten-1"
      else return "blue lighten-1"
    },

    // 보안 교육 현황 가져오기
    GetPledgeLog(){
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
      };
      axios
        .post(process.env.VUE_APP_UIL_API + "GetPledgeLog", posData, {
          headers: {
            "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            for (let i = 0; i <6;i++){
              let ResultObj = {}
              if (i == 0) {
                ResultObj.cPledgeId = "A0001"
                ResultObj.cAgree = res.data.Result[0].cPledge1
                ResultObj.cPledgeDateTime = res.data.Result[0].cPledge1DateTime
                ResultObj.cCustomNm = res.data.Result[0].cCustomNm
                ResultObj.cType = "보안 서약서"
                this.Records.push(ResultObj)
              }
              if (i == 1) {
                ResultObj.cPledgeId = "A0002"
                ResultObj.cAgree = res.data.Result[0].cPledge2
                ResultObj.cPledgeDateTime = res.data.Result[0].cPledge2DateTime
                ResultObj.cCustomNm = res.data.Result[0].cCustomNm
                ResultObj.cType = "개인정보 수집 및 이용 동의서"
                this.Records.push(ResultObj)
              }
              if (i == 2) {
                ResultObj.cPledgeId = "A0003"
                ResultObj.cAgree = res.data.Result[0].cPledge3
                ResultObj.cPledgeDateTime = res.data.Result[0].cPledge3DateTime
                ResultObj.cCustomNm = res.data.Result[0].cCustomNm
                ResultObj.cType = "위치정보 수집 및 이용 동의서"
                this.Records.push(ResultObj)
              }
              if (i == 3) {
                ResultObj.cPledgeId = "A0004"
                ResultObj.cAgree = res.data.Result[0].cPledge4
                ResultObj.cPledgeDateTime = res.data.Result[0].cPledge4DateTime
                ResultObj.cCustomNm = res.data.Result[0].cCustomNm
                ResultObj.cType = "보안 교육서약서"
                this.Records.push(ResultObj)
              }
              if (i == 4) {
                ResultObj.cPledgeId = "A0005"
                ResultObj.cAgree = res.data.Result[0].cPledge5
                ResultObj.cPledgeDateTime = res.data.Result[0].cPledge5DateTime
                ResultObj.cCustomNm = res.data.Result[0].cCustomNm
                ResultObj.cType = "환경안전사고 예방 서약서"
                this.Records.push(ResultObj)
              }
              if (i == 5) {
                ResultObj.cPledgeId = "A0006"
                ResultObj.cAgree = res.data.Result[0].cPledge6
                ResultObj.cPledgeDateTime = res.data.Result[0].cPledge6DateTime
                ResultObj.cCustomNm = res.data.Result[0].cCustomNm
                ResultObj.cType = "골든룰 위반 패널티 동의서"
                this.Records.push(ResultObj)
              }
            }
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
  }
}
</script>